import React from 'react';
import { Settings } from 'luxon';

import { constants } from '../../config';
import { AppTemplate } from '../AppTemplate';
import { routeConfig } from './routes';

Settings.defaultLocale = constants.dateLocale;

const App = () => (
  <AppTemplate routeConfig={routeConfig} />
);

export default App;



// WEBPACK FOOTER //
// ./src/apps/checkout/App.js